import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Building2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-treasury-check/bank/admin/lookups`;

export const BankLookupLog = ({ checkId, token }) => {
  const [d, setD] = useState(null);
  const [all, setAll] = useState(false);
  useEffect(() => {
    axios.get(`${API}/${checkId}`, { headers: { Authorization: `Bearer ${token}` } }).then(r => setD(r.data)).catch(() => setD({ lookups: [], total: 0, matched: 0 }));
  }, [checkId, token]);
  if (!d) return null;
  return (
    <div className="max-w-4xl mx-auto px-4 pt-6 print:hidden" data-testid="bank-lookup-log">
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-5">
        <h3 className="text-white font-semibold flex items-center gap-2 mb-1"><Building2 className="w-5 h-5 text-cyan-400" /> Bank lookups</h3>
        <p className="text-xs text-slate-400 mb-3" data-testid="bank-lookup-log-summary">{d.total} lookup{d.total === 1 ? '' : 's'} · {d.matched} matched · {d.total - d.matched} refused</p>
        {!d.lookups.length ? <p className="text-sm text-slate-500" data-testid="bank-lookup-log-empty">No bank has looked up this check yet.</p> : (
          <div className="overflow-x-auto"><table className="w-full text-sm text-slate-300">
            <thead><tr className="text-left text-xs text-slate-500"><th className="py-1">When</th><th>Routing</th><th>Account</th><th>Check no.</th><th>Result</th><th>IP</th></tr></thead>
            <tbody>{(all ? d.lookups : d.lookups.slice(0, 5)).map(l => (
              <tr key={l.id} className="border-t border-slate-700" data-testid={`bank-lookup-row-${l.id}`}>
                <td className="py-1.5 text-xs">{new Date(l.at).toLocaleString()}</td><td className="font-mono text-xs">{l.rt}</td>
                <td className="font-mono text-xs">••••{l.acct_last4}</td><td className="text-xs">{l.chk || '-'}</td>
                <td><span className={`text-xs px-2 py-0.5 rounded ${l.matched ? 'bg-emerald-500/20 text-emerald-300' : 'bg-red-500/20 text-red-300'}`}>{l.matched ? 'Matched' : 'Refused'}</span></td>
                <td className="font-mono text-xs">{l.ip || '-'}</td>
              </tr>
            ))}</tbody>
          </table>
          {d.lookups.length > 5 && <button onClick={() => setAll(!all)} className="mt-2 text-xs text-cyan-300 underline" data-testid="bank-lookup-log-toggle">{all ? 'Show latest 5' : `Show all ${d.lookups.length}`}</button>}
          </div>
        )}
      </div>
    </div>
  );
};
